import { useSelector } from "react-redux";
import { RootState } from "redux/app/store";
import { IUser, IUserArtist } from "types/user";

export const GetUser = () => {
  const UnParsedUser = localStorage.getItem("userData") || "";
  if (!UnParsedUser || UnParsedUser === "undefined") {
    return null;
  }
  const User: IUser = JSON.parse(UnParsedUser);
  if (!User) return null;
  return User;
};

export const GetUserArtists = () => {
  const User: IUser | null = GetUser();
  if (User && User.artistProfiles) return User.artistProfiles;
  return [];
};

export const GetActiveArtist = () => {
  const activeArtist = useSelector(
    (state: RootState) => state.Artist.activeArtist
  );

  const User: IUser | null = GetUser();
  if (!User?.artistProfiles) return null;
  for (let i = 0; i < User.artistProfiles?.length; i++) {
    if (User.artistProfiles[i].id === activeArtist) {
      return User.artistProfiles[i];
    }
  }
  return User.artistProfiles[0];
};

export const GetArtistData = (id: string) => {
  const User: IUser | null = GetUser();
  if (!User?.artistProfiles) return null;
  for (let i = 0; i < User.artistProfiles?.length; i++) {
    if (User.artistProfiles[i].id === id) {
      return User.artistProfiles[i];
    }
  }
  return User.artistProfiles[0];
};

export const FindArtisByName = (name: string) => {
  let temp = GetUserArtists();
  for (let i = 0; i < temp.length; i++) {
    if (temp[i].name === name) {
      return temp[i];
    }
  }
  return null;
};

export const FindArtistById = (id: string) => {
  let artists = GetUserArtists();
  for (let i = 0; i < artists.length; i++) {
    if (artists[i].id === id) {
      return artists[i];
    }
  }
  return null;
};
